import {createSelector} from 'reselect';
import {getSelectedDeliveryOptionIDList} from './DeliveryOptionsSelectors';

export default createSelector(
  [getSelectedDeliveryOptionIDList],
  selectedDeliveryOptionIDList => !!(selectedDeliveryOptionIDList?.includes(58)),
);
